import { SingleHSCodePredictions } from 'src/model/aiHSCodeLabeling';
import { CountryTariffs, CustomDuties, Fta, NtmMeasures, ProductTariffs, RooFta, TradeRemedy } from 'src/model/tariffs';
import { getRequest, postRequest } from 'src/services/api/http';
import { API_KEY_WIDGET } from 'src/utils/constants/config';
import { URL_ENDPOINT } from 'src/utils/constants/service';

const PublicService = {
  getCountryTariffs,
  searchHsCodeTariffs,
  searchNationalCodeTariffs,
  getNtmMeasures,
  getCustomDuties,
  getTradeRemedy,
  getRegimeCountryTariffs,
  getFtaTariffs,
  getRooFtaTariffs,
  getSentencePrediction,
};

export default PublicService;

function getCountryTariffs() {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'countries';
  return getRequest(url, {}, new CountryTariffs(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<CountryTariffs>;
}

function searchHsCodeTariffs({ countryCode, level, keyword }: { countryCode: string; level: number; keyword: string }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'products-by-keyword';
  return getRequest(url, { countryCode, level, keyword }, new ProductTariffs(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<ProductTariffs>;
}

function searchNationalCodeTariffs({
  countryCode,
  level,
  hsCode,
}: {
  countryCode: string;
  level: number;
  hsCode: string;
}) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'ntlc-products';
  return getRequest(url, { countryCode, level, code: hsCode }, new ProductTariffs(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<ProductTariffs>;
}

function getNtmMeasures({ reporter, partner, product }: { reporter: string; partner: string; product: string }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'ntm-measures';
  return getRequest(url, { reporter, partner, product }, new NtmMeasures(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<NtmMeasures>;
}

function getCustomDuties({ reporter, partner, product }: { reporter: string; partner: string; product: string }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'custom-duties';
  return getRequest(url, { reporter, partner, product }, new CustomDuties(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<CustomDuties>;
}

function getTradeRemedy({ reporter, partner, product }: { reporter: string; partner: string; product: string }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'trade-remedy';
  return getRequest(url, { reporter, partner, product }, new TradeRemedy(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<TradeRemedy>;
}

function getRegimeCountryTariffs({ reporter, agId }: { reporter: string; agId: number }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'tariff-regime-country-list';
  return getRequest(url, { reporter, agId, year: 'latest' }, new CountryTariffs(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<CountryTariffs>;
}

function getFtaTariffs({
  reporter,
  partner,
  product,
  ftaId,
}: {
  reporter: string;
  partner: string;
  product: string;
  ftaId: number;
}) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'fta';
  return getRequest(url, { reporter, partner, product, ftaId }, new Fta(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<Fta>;
}

function getRooFtaTariffs({ reporter, partner, ftaId }: { reporter: string; partner: string; ftaId: number }) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.tariffsAndRules.v2 + 'roo-by-fta';
  return getRequest(url, { reporter, partner, ftaId }, new RooFta(), {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<RooFta>;
}

function getSentencePrediction(dto: Record<string, string>) {
  const apiKeyWidget = localStorage.getItem(API_KEY_WIDGET);
  const url = URL_ENDPOINT.public.aiLabeling.sentenceHSCodePrediction;
  return postRequest(url, dto, {
    'X-API-KEY': apiKeyWidget || '',
  }) as Promise<SingleHSCodePredictions>;
}
